import React, { useEffect, useState } from "react";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
  Navigate,
} from "react-router-dom";
import { useSelector } from "react-redux";

// ... (All your page component imports remain unchanged)
import Navbar from "./commons/Navbar/Navbar";
import Error from "./pages/Error/Error";
import Pages_home from "./pages/OpenAccess/Home/Pages_home";
import Pages_Register from "./pages/OpenAccess/Register/Pages_Register";
import Pages_Login from "./pages/OpenAccess/Login/Pages_Login";
import Pages_About from "./pages/OpenAccess/About/Pages_About";
import Pages_contract from "./pages/OpenAccess/Contact/Pages_contract";
import Pages_Faqs from "./pages/OpenAccess/Faqs/Pages_Faqs";
import Pages_Lcc from "./pages/OpenAccess/Lcc/Pages_Lcc";
import Common_Profile from "./pages/TokenAccess/Common/Profile/Common_Profile";
import Common_document from "./pages/TokenAccess/Common/Document/Common_document";
import Common_Company_Admin from "./pages/TokenAccess/Common/Admin/Common_Company_Admin";
import Trader_Dashboard from "./pages/TokenAccess/Trader/Dashboard/Trader_Dashboard";
import Trader_Admin from "./pages/TokenAccess/Trader/Admin/Trader_Admin";
import Banking_Dashboard from "./pages/TokenAccess/Banking/Dashboard/Banking_Dashboard";
import Banking_Past_Listing from "./pages/TokenAccess/Banking/PastListing/Banking_Past_Listing";
import Banking_Search from "./pages/TokenAccess/Banking/SearchConnect/Banking_Search";
import Consumer_Generator_Dashboard from "./pages/TokenAccess/ConsumerGenerator/Dashboard/Consumer_Generator_Dashboard";
import Consumer_Generator_Past from "./pages/TokenAccess/ConsumerGenerator/PastListing/Consumer_Generator_Past";
import Consumer_Generator_Search from "./pages/TokenAccess/ConsumerGenerator/SearchConnect/Consumer_Generator_Search";
import Consumer_Generator_Received from "./pages/TokenAccess/ConsumerGenerator/Received/Consumer_Generator_Received";
import Pages_Upload_Lcc from "./pages/Analyst/UploadLCC/Pages_Upload_Lcc";
import Admin_Dashboard from "./pages/Analyst/Dashboard/Admin_Dashboard";
import Admin_Company from "./pages/Analyst/Company/Admin_Company";
import AuctionPageDashboard from "./pages/TokenAccess/ConsumerGenerator/Auction/AuctionPageDashboard";
import LedgerPageDashboard from "./pages/TokenAccess/ConsumerGenerator/Ledger/LedgerPageDashboard";
import Ledger from "./pages/TokenAccess/Banking/Ledger/Ledger";
import SideNavBar from "./Components/SideNavBar/SideNavBar";
import ReverseAuction from "./pages/TokenAccess/ConsumerGenerator/Auction/ReverseAuction/ReverseAuction";
import Bidding from "./pages/TokenAccess/ConsumerGenerator/Auction/ReverseAuction/Bidding";
import LiveReverseAuction from "./pages/TokenAccess/ConsumerGenerator/Auction/ReverseAuction/LiveReverseAuction";
import Ongoing from "./pages/TokenAccess/ConsumerGenerator/Ongoing/Ongoing";
import LiveReverseAuctionOngoing from "./pages/TokenAccess/ConsumerGenerator/Auction/ReverseAuction/LiveReverseAuctionOngoing";
import TenderOngoing from "./pages/TokenAccess/ConsumerGenerator/Auction/ReverseAuction/TenderOngoing";
import TenderActive from "./pages/TokenAccess/ConsumerGenerator/Auction/ReverseAuction/TenderActive";
import PaymentLedger from "./pages/TokenAccess/PaymentLedger/PaymentLedger";
import ConnectionRequestPage from "./pages/TokenAccess/Banking/LedgerTabs/ConnectionRequestPage";
import ActiveLedgerPage from "./pages/TokenAccess/Banking/LedgerTabs/ActiveLedgerPage";
import OngoingLedgerPage from "./pages/TokenAccess/Banking/LedgerTabs/OngoingLedgerPage";
import Page_Transaction from "./pages/TokenAccess/PaymentLedger/Page_Transaction";
import Page_Contract from "./pages/TokenAccess/PaymentLedger/Page_Contract";
import Page_Super_Admin_dash from "./pages/TokenAccess/GNA/Page_Super_Admin_dash";
import Page_Admin_company from "./pages/TokenAccess/GNA/Page_Admin_company";
import ForgetPassword from "./Components/Auth/Forget/ForgetPassword";
import getDashboardPath from "./helpers/getDashboardPath";
import UnifiedLedger from "./pages/TokenAccess/Common/UnifiedLedger/Unified_Ledger";
import RfqContainer from "./pages/TokenAccess/ConsumerGenerator/Auction/ReverseAuction/RfqContainer";
import Page_Archive from "./pages/TokenAccess/Archive/Page_Archive";
import NewLedger from "./pages/TokenAccess/ConsumerGenerator/NewLedger";
import Pages_Coming_Soon from "./pages/OpenAccess/ComingSoon/Pages_Coming_Soon";

// --- ACCESS LISTS (Updated for path consistency) ---

const PUBLIC_ROUTES = [
  "/login",
  "/register",
  "/faqs",
  "/contact",
  "/about_us",
  "/lcc",
  "/forgot_password",
  // Removed "/" from here
];

const COMMON_PRIVATE_ROUTES = [
  "/my_profile",
  "/my_documents",
  "/wallet",
  "/wallet_transaction",
  "/wallet_contract",
  "/unified_ledger",
  "/archive",
];

const ANALYST_ACCESS = [
  "/upload_sheet",
  "/analyst_dashboard",
  "/analyst_profile",
  ...PUBLIC_ROUTES,
];

const COMPANY_ADMIN_ACCESS = [
  "/admin_company_dashboard",
  ...COMMON_PRIVATE_ROUTES,
  ...PUBLIC_ROUTES,
];

const ADMIN_TRADER_ACCESS = [
  "/admin_trader_dashboard",
  ...COMMON_PRIVATE_ROUTES,
  ...PUBLIC_ROUTES,
];

const CONSUMER_ACCESS = [
  "/dashboard",
  "/ledger",
  "/ongoing",
  "/search_listing",
  "/past_listing_con_gen",
  "/auction",
  "/reverse_auction",
  "/rfq",
  "/tender_ongoing",
  "/tender_active",
  "/live_auction",
  "/reverse_auction_ongoing",
  "/bilateral",
  "/bidding",
  ...COMMON_PRIVATE_ROUTES,
  ...PUBLIC_ROUTES,
];

const GENERATOR_ACCESS = [
  "/dashboard",
  "/ledger",
  "/ongoing",
  "/search_listing",
  "/past_listing_con_gen",
  "/auction",
  "/reverse_auction",
  "/rfq",
  "/tender_ongoing",
  "/tender_active",
  "/live_auction",
  "/reverse_auction_ongoing",
  "/bilateral",
  "/bidding",
  ...COMMON_PRIVATE_ROUTES,
  ...PUBLIC_ROUTES,
];

const TRADER_ACCESS = [
  "/trader_dashboard",
  ...COMMON_PRIVATE_ROUTES,
  ...PUBLIC_ROUTES,
];

const BANKING_ACCESS = [
  "/banking",
  "/banking_ledger",
  "/banking_connection",
  "/banking_active",
  "/banking_ongoing",
  "/banking_past_listing",
  "/banking_search",
  ...COMMON_PRIVATE_ROUTES,
  ...PUBLIC_ROUTES,
];

const GNA_ACCESS = [
  "/admin_dashboard",
  "/admin_dashboard_company",
  ...COMMON_PRIVATE_ROUTES,
  ...PUBLIC_ROUTES,
];

const ACCESS_MAP = {
  ANALYST: ANALYST_ACCESS,
  COMPANY_ADMIN: COMPANY_ADMIN_ACCESS,
  ADMIN_TRADER: ADMIN_TRADER_ACCESS,
  CONSUMER: CONSUMER_ACCESS,
  GENERATOR: GENERATOR_ACCESS,
  TRADER: TRADER_ACCESS,
  BANKING: BANKING_ACCESS,
  SUPER_ADMIN: GNA_ACCESS,
  MAKER: GNA_ACCESS,
  CHECKER: GNA_ACCESS,
};

// --- PrivateRoute Component ---
const PrivateRoute = ({ children }) => {
  const token = useSelector((state) => state?.persistedReducer?.token);
  const userType = useSelector((state) => state?.persistedReducer?.userType);
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const allowedPaths = ACCESS_MAP[userType];
  const dashboardPath = getDashboardPath(userType);

  if (!allowedPaths) {
    console.warn(`No access list defined for userType: ${userType}`);
    return <Navigate to={dashboardPath || "/login"} replace />;
  }

  if (allowedPaths.includes(location.pathname)) {
    return children;
  }

  console.warn(
    `User ${userType} unauthorized for path: ${location.pathname}. Redirecting to dashboard.`
  );
  return <Navigate to={dashboardPath} state={{ from: location }} replace />;
};

// --- PublicRoute Component ---
const PublicRoute = ({ children }) => {
  const token = useSelector((state) => state?.persistedReducer?.token);
  const userType = useSelector((state) => state?.persistedReducer?.userType);

  if (token) {
    return <Navigate to={getDashboardPath(userType)} replace />;
  }

  return children;
};

// --- ROUTES CONFIGURATION ---
export const routes = [
  // GNA
  { path: "/admin_dashboard", element: Page_Super_Admin_dash },
  { path: "/admin_dashboard_company", element: Page_Admin_company },

  // Common_user
  { path: "/my_profile", element: Common_Profile },
  { path: "/my_documents", element: Common_document },
  { path: "/admin_company_dashboard", element: Common_Company_Admin },
  { path: "/wallet", element: PaymentLedger },
  { path: "/wallet_transaction", element: Page_Transaction },
  { path: "/wallet_contract", element: Page_Contract },
  { path: "/unified_ledger", element: UnifiedLedger },
  { path: "/archive", element: Page_Archive },

  // Trader
  { path: "/trader_dashboard", element: Trader_Dashboard },
  { path: "/admin_trader_dashboard", element: Trader_Admin },

  // Banking
  { path: "/banking", element: Banking_Dashboard },
  { path: "/banking_ledger", element: Ledger },
  { path: "/banking_connection", element: ConnectionRequestPage },
  { path: "/banking_active", element: ActiveLedgerPage },
  { path: "/banking_ongoing", element: OngoingLedgerPage },
  { path: "/banking_past_listing", element: Banking_Past_Listing },
  { path: "/banking_search", element: Banking_Search },

  // Consumer Generator
  { path: "/dashboard", element: Consumer_Generator_Dashboard },
  { path: "/ledger", element: NewLedger },
  { path: "/ongoing", element: Ongoing },
  { path: "/search_listing", element: Consumer_Generator_Search },
  { path: "/past_listing_con_gen", element: Consumer_Generator_Past },
  { path: "/rfq", element: RfqContainer },
  { path: "/reverse_auction", element: ReverseAuction },
  { path: "/live_auction", element: LiveReverseAuction },
  { path: "/reverse_auction_ongoing", element: LiveReverseAuctionOngoing },
  { path: "/tender_ongoing", element: TenderOngoing },
  { path: "/tender_active", element: TenderActive },
  { path: "/bidding", element: Bidding },
  { path: "/bilateral", element: LedgerPageDashboard },

  // Analyst
  { path: "/upload_sheet", element: Pages_Upload_Lcc },
  { path: "/analyst_dashboard", element: Admin_Dashboard },
  { path: "/analyst_profile", element: Admin_Company },

  // Common without token
  { path: "/lcc", element: Pages_Lcc },
  { path: "/faqs", element: Pages_Faqs },
  { path: "/contact", element: Pages_contract },
  { path: "/about_us", element: Pages_About },
  { path: "/login", element: Pages_Login },
  { path: "/register", element: Pages_Register },
  { path: "/forgot_password", element: ForgetPassword },
  { path: "/coming-soon", element: Pages_Coming_Soon },

  // REMOVED: { path: "/", element: Pages_Login }

  { path: "*", element: Error },
];

const Routing = () => {
  const token = useSelector((state) => state?.persistedReducer?.token);
  const userType = useSelector((state) => state?.persistedReducer?.userType);
  console.debug("Routing Token:", userType);
  const [navOpen, setNavOpen] = useState(() => {
    const stored = localStorage.getItem("OTC_NAV_OPEN");
    if (stored !== null) {
      return stored === "true";
    }

    return !(
      userType === "SUPER_ADMIN" ||
      userType === "MAKER" ||
      userType === "CHECKER" ||
      userType === "ADMIN"
    );
  });

  useEffect(() => {
    const stored = localStorage.getItem("OTC_NAV_OPEN");
    if (stored === null) {
      setNavOpen(
        !(
          userType === "SUPER_ADMIN" ||
          userType === "MAKER" ||
          userType === "CHECKER" ||
          userType === "ADMIN"
        )
      );
    }
  }, [userType]);

  return (
    <Router>
      <RoutingContent
        token={token}
        userType={userType}
        navOpen={navOpen}
        setNavOpen={setNavOpen}
      />
    </Router>
  );
};

// --- UPDATED: RoutingContent Component ---
const RoutingContent = ({ userType, navOpen, setNavOpen }) => {
  const token = useSelector((state) => state?.persistedReducer?.token);
  const location = useLocation();

  const hideNavRoutes = ["/login", "/register", "/forgot_password"]; // Removed "/"
  const shouldHideNav = hideNavRoutes.includes(location.pathname);

  const handleNavSwitch = () => {
    setNavOpen((prev) => {
      const next = !prev;
      localStorage.setItem("OTC_NAV_OPEN", String(next));
      return next;
    });
  };

  const publicAuthPaths = ["/login", "/register", "/forgot_password"];
  const publicPaths = [
    "/lcc",
    "/faqs",
    "/contact",
    "/about_us",
    "/coming-soon",
    "*",
  ]; // Removed "/"

  const routeElements = routes.map((route) => {
    const { path, element: Component } = route;

    if (publicAuthPaths.includes(path)) {
      return (
        <Route
          key={path}
          path={path}
          element={
            <PublicRoute>
              <Component />
            </PublicRoute>
          }
        />
      );
    }

    if (publicPaths.includes(path)) {
      return <Route key={path} path={path} element={<Component />} />;
    }

    return (
      <Route
        key={path}
        path={path}
        element={
          <PrivateRoute>
            <Component />
          </PrivateRoute>
        }
      />
    );
  });

  return (
    <>
      {token && !shouldHideNav && (
        <div className="nav_top_container">
          <Navbar />
        </div>
      )}
      {token && !shouldHideNav ? (
        <div className="main_container_routing">
          {!(
            userType === "SUPER_ADMIN" ||
            userType === "MAKER" ||
            userType === "CHECKER" ||
            userType === "ADMIN"
          ) && (
            <div className={navOpen ? "side_nav_main_cont" : "side_nav_closed"}>
              <SideNavBar
                userType={userType}
                navOpen={navOpen}
                onNavSwitch={handleNavSwitch}
              />
            </div>
          )}
          <div
            className={
              userType === "SUPER_ADMIN" ||
              userType === "MAKER" ||
              userType === "CHECKER" ||
              userType === "ADMIN"
                ? "display_main_cont_open_sadmin"
                : navOpen
                ? "display_main_cont_open"
                : "display_main_cont_closed"
            }
          >
            <Routes>
              {/* Add the redirect for the root path explicitly here.
                   This redirects localhost:3000/ -> localhost:3000/login 
                */}
              <Route path="/" element={<Navigate to="/login" replace />} />
              {routeElements}
            </Routes>
          </div>
        </div>
      ) : (
        <div className="display_main_cont_open_tokenless">
          <Routes>
            {/* Add the redirect here as well for when user is not logged in
             */}
            <Route path="/" element={<Navigate to="/login" replace />} />
            {routeElements}
          </Routes>
        </div>
      )}
      <div className="footer_container">Footer</div>
    </>
  );
};

export default Routing;
